var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-card topup"},[_c('div',{staticClass:"topup-header"},[_vm._v(_vm._s(_vm.$t('topUp')))]),_c('div',{staticClass:"topup-online"},[(_vm.$route.query.type)?_c('instant'):_c('online')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }